import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './../App.css';
import PageShell from '../components/layout/PageShell';

const NotFoundPage = () => {
    useEffect(() => {
        document.title = '404 animix';
    }, []);

    return (
        <PageShell className="not-found-page">
            <div className="not-found">
                <p className="not-found__code" aria-hidden="true">404</p>
                <h1 className="not-found__title">Тут ничего нет</h1>
                <p className="not-found__text">Скорее всего, вы попали на эту страницу случайно. Пока что здесь пусто, мяу.</p>
                <Link to="/" className="ui-btn ui-btn--light">На главную</Link>
            </div>
        </PageShell>
    );
};

export default NotFoundPage;
